/**
 * Mixpanel full API Mock - 28.8.2015
 * https://mixpanel.com/help/reference/javascript-full-api-reference
 */
import { Mixpanel } from '../chili-track/chili-mixpanel'

class MixpanelMock implements Mixpanel {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  identify() {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {}

  people = {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    increment: () => {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    set: () => {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    set_once: () => {},
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  register() {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  track() {}
}

export default new MixpanelMock()
